import { createSelector } from '@app/utils/createSelector'

import type { Result } from '@app/packages/Result/Result'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'

import { announcementsHiddenSelector, announcementsMetaSelector, announcementsRawIdsListSelector } from '@app/store/slices/announcements'
import { createAnnouncementBundleSelector } from '@app/store/slices/bundles'
import { profilePlaceAddressLocationResultSelector } from '@app/store/slices/profile_place'

import { profileSitterAddressSelector } from './profile'

export const announcementsIdsListSelector = createSelector([announcementsRawIdsListSelector, announcementsHiddenSelector], (list, hidden) => {
  return list.filter(id => !hidden[id])
})

export const announcementsListSelector = createSelector(
  [(state: unknown) => state],
  state => {
    const ids = announcementsIdsListSelector(state)
    const models = ids.map(id => createAnnouncementBundleSelector(id)(state))
    return models
  },
  {
    resultEqual(a, b) {
      if (a.length !== b.length) return false
      for (let i = 0; i < a.length; i++) {
        if (!resultEqual(a[i], b[i])) return false
      }
      return true
    },
  }
)

export const announcementsCompleteSelector = createSelector([announcementsMetaSelector], meta => meta.cursor === null)

export const announcementCountSelector = createSelector([announcementsIdsListSelector], list => list.length)

export const announcementsSearchAddressResultSelector = createSelector(
  [profileSitterAddressSelector, profilePlaceAddressLocationResultSelector],
  (sitterAddress, profilePlaceAddressResult) =>
    createLoadable(c => {
      return sitterAddress ?? c.unwrap(profilePlaceAddressResult)
    })
)

const resultEqual = <T>(a: Result<T>, b: Result<T>) => {
  if (a.error && b.error) return errorEqual(a.value, b.value)
  if (!a.error && !b.error) return a.value === b.value
  return false
}

const errorEqual = (a: unknown, b: unknown) => {
  if (a instanceof Error && b instanceof Error) return a.message === b.message
  return false
}
